// Source-language text for the "No onions / Less spicy / On the side" quick
// chips in the DishSheet. What lands on the waiter's hand-off screen is the
// source-language version — if the user taps "No onions" but the menu is in
// Japanese, the waiter reads ねぎ抜きでお願いします.
//
// PENDING native-speaker QA before public launch. Claude+author seed 2026-04.

export type QuickModKind = 'no_onion' | 'less_spicy' | 'on_side';

const PHRASES: Record<QuickModKind, Record<string, string>> = {
  no_onion: {
    en: 'No onions, please.',
    es: 'Sin cebolla, por favor.',
    fr: 'Sans oignons, s’il vous plaît.',
    it: 'Senza cipolle, per favore.',
    de: 'Ohne Zwiebeln, bitte.',
    pt: 'Sem cebola, por favor.',
    nl: 'Geen uien, alstublieft.',
    ja: 'ねぎ抜きでお願いします。',
    zh: '请不要洋葱。',
    'zh-TW': '請不要洋蔥。',
    ko: '양파 빼주세요.',
    th: 'ไม่ใส่หัวหอม ขอบคุณ',
    vi: 'Không hành, cảm ơn.',
    ar: 'بدون بصل من فضلك.',
    he: 'בלי בצל בבקשה.',
    tr: 'Soğansız, lütfen.',
    el: 'Χωρίς κρεμμύδι, παρακαλώ.',
    ru: 'Без лука, пожалуйста.',
    pl: 'Bez cebuli, proszę.',
    hi: 'कृपया प्याज़ मत डालें।',
    id: 'Tolong tanpa bawang.',
    cs: 'Bez cibule, prosím.',
    uk: 'Без цибулі, будь ласка.',
  },
  less_spicy: {
    en: 'Less spicy, please.',
    es: 'Menos picante, por favor.',
    fr: 'Moins épicé, s’il vous plaît.',
    it: 'Meno piccante, per favore.',
    de: 'Weniger scharf, bitte.',
    pt: 'Menos picante, por favor.',
    nl: 'Minder pittig, alstublieft.',
    ja: '辛さ控えめでお願いします。',
    zh: '请少辣。',
    'zh-TW': '請少辣。',
    ko: '덜 맵게 해주세요.',
    th: 'ขอเผ็ดน้อย',
    vi: 'Ít cay, cảm ơn.',
    ar: 'أقل توابل من فضلك.',
    he: 'פחות חריף בבקשה.',
    tr: 'Daha az acılı, lütfen.',
    el: 'Λιγότερο πικάντικο, παρακαλώ.',
    ru: 'Поменьше острого, пожалуйста.',
    pl: 'Mniej ostre, proszę.',
    hi: 'कृपया कम मसालेदार।',
    id: 'Tolong tidak terlalu pedas.',
    cs: 'Méně pálivé, prosím.',
    uk: 'Менш гостре, будь ласка.',
  },
  on_side: {
    en: 'On the side, please.',
    es: 'Aparte, por favor.',
    fr: 'À part, s’il vous plaît.',
    it: 'A parte, per favore.',
    de: 'Separat, bitte.',
    pt: 'À parte, por favor.',
    nl: 'Apart, alstublieft.',
    ja: '別添えでお願いします。',
    zh: '请分开装。',
    'zh-TW': '請分開裝。',
    ko: '따로 주세요.',
    th: 'ขอแยกต่างหาก',
    vi: 'Để riêng, cảm ơn.',
    ar: 'على جانب من فضلك.',
    he: 'בצד בבקשה.',
    tr: 'Ayrı olarak, lütfen.',
    el: 'Ξεχωριστά, παρακαλώ.',
    ru: 'Отдельно, пожалуйста.',
    pl: 'Osobno, proszę.',
    hi: 'कृपया अलग से।',
    id: 'Tolong dipisah.',
    cs: 'Zvlášť, prosím.',
    uk: 'Окремо, будь ласка.',
  },
};

// Returns the source-language phrase. Falls back to English if the source
// language isn't in the phrasebook yet — the waiter can still roughly parse
// "No onions, please." better than nothing.
export function quickModFor(kind: QuickModKind, sourceLanguage: string): string {
  return PHRASES[kind][sourceLanguage] ?? PHRASES[kind].en!;
}
